var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStarInBox = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5f63ee",
  d: "m9.323 4.198 1.487 2.946 2.862.284a.358.358 0 0 1 .222.61l-2.355 2.335.873 3.173a.361.361 0 0 1-.512.415L9 12.526 6.1 13.96a.361.361 0 0 1-.511-.416l.873-3.172-2.357-2.335a.358.358 0 0 1 .222-.61l2.862-.284 1.485-2.945a.364.364 0 0 1 .648 0"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 17,
  height: 17,
  x: 0.5,
  y: 0.5,
  stroke: "#5f63ee",
  rx: 2.5
})));
export default SvgStarInBox;